import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tiposAtributos: [],
  fetchTiposAtributosLoading: false,
  fetchTiposAtributosError: null,

  addTipoAtributoLoading: false,
  addTipoAtributoError: null,

  updateTipoAtributoLoading: false,
  updateTipoAtributoError: null,

  deleteTipoAtributoLoading: false,
  deleteTipoAtributoError: null
};

export const tipoAtributosSlice = createSlice({
  name: 'TIPOATRIBUTOS',
  initialState,
  reducers: {
    fetchTiposAtributosStart: state => {
      state.fetchTiposAtributosLoading = true;
      state.fetchTiposAtributosError = null;
    },
    fetchTiposAtributosSuccess: (state, action) => {
      state.fetchTiposAtributosLoading = false;
      state.tiposAtributos = action.payload;
    },
    fetchTiposAtributosError: (state, action) => {
      state.fetchTiposAtributosLoading = false;
      state.fetchTiposAtributosError = action.payload;
    },

    addTipoAtributoStart: state => {
      state.addTipoAtributoLoading = true;
      state.addTipoAtributoError = null;
    },
    addTipoAtributoSuccess: (state, action) => {
      state.addTipoAtributoLoading = false;
      state.tiposAtributos.unshift(action.payload);
    },
    addTipoAtributoError: (state, action) => {
      state.addTipoAtributoLoading = false;
      state.addTipoAtributoError = action.payload;
    },

    updateTipoAtributoStart: state => {
      state.updateTipoAtributoLoading = true;
      state.updateTipoAtributoError = null;
    },
    updateTipoAtributoSuccess: (state, action) => {
      state.updateTipoAtributoLoading = false;
      const newState = state.tiposAtributos.map(tipoAtr => {
        if (tipoAtr.id === action.payload.id) return action.payload;
        return tipoAtr;
      });
      state.tiposAtributos = newState;
    },
    updateTipoAtributoError: (state, action) => {
      state.updateTipoAtributoLoading = false;
      state.updateTipoAtributoError = action.payload;
    },

    deleteTipoAtributoStart: state => {
      state.deleteTipoAtributoLoading = true;
      state.deleteTipoAtributoError = null;
    },
    deleteTipoAtributoSuccess: (state, action) => {
      state.deleteTipoAtributoLoading = false;
      const newState = state.tiposAtributos.filter(
        tipoAtr => tipoAtr.id !== action.payload.id
      );
      state.tiposAtributos = newState;
    },
    deleteTipoAtributoError: (state, action) => {
      state.deleteTipoAtributoLoading = false;
      state.deleteTipoAtributoError = action.payload;
    }
  }
});

export const {
  fetchTiposAtributosStart,
  fetchTiposAtributosSuccess,
  fetchTiposAtributosError,
  addTipoAtributoStart,
  addTipoAtributoSuccess,
  addTipoAtributoError,
  updateTipoAtributoStart,
  updateTipoAtributoSuccess,
  updateTipoAtributoError,
  deleteTipoAtributoStart,
  deleteTipoAtributoSuccess,
  deleteTipoAtributoError
} = tipoAtributosSlice.actions;

export default tipoAtributosSlice.reducer;
